<template>
  <header class="header">
    <div class="overlay" ref="overlay"></div>
    <div class="sideslide" ref="sideslide">
      <a href="#" class="show-for-medium">EN</a>
      <a :href="`https://www.${domain}/account/login`">{{$t("loginLinkText")}}</a>
    </div>
    <div class="top_part">
      <a ref="hamburger" @click="menuClick" class="open hide-for-medium" href="#">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="25"
          height="25"
          viewBox="0 0 19 12"
          class="mdl-js"
        >
          <path
            id="Rounded_Rectangle_4_copy_2"
            data-name="Rounded Rectangle 4 copy 2"
            class="cls-1"
            d="M4933,47h17a1,1,0,1,1,0,2h-17A1,1,0,1,1,4933,47Zm0-5h17a1,1,0,0,1,0,2h-17A1,1,0,0,1,4933,42Zm0-5h17a1,1,0,1,1,0,2h-17A1,1,0,1,1,4933,37Z"
            transform="translate(-4932 -37)"
          ></path>
        </svg>
      </a>
      <a @click="closeClick" ref="close" class="close hide-for-medium" href="#">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          version="1.1"
          width="25"
          height="25"
          viewBox="0 0 20 20"
          enable-background="new 0 0 20 20"
          xml:space="preserve"
          class="mdl-js"
        >
          <g>
            <path
              fill="#FFFFFF"
              d="M13.2,6.8c-0.4-0.4-1-0.4-1.4,0L10,8.6L8.2,6.8c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4L8.6,10l-1.8,1.8   c-0.4,0.4-0.4,1,0,1.4c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3l1.8-1.8l1.8,1.8c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3   c0.4-0.4,0.4-1,0-1.4L11.4,10l1.8-1.8C13.6,7.8,13.6,7.2,13.2,6.8z"
            ></path>
            <path
              fill="#FFFFFF"
              d="M10,0.2c-5.4,0-9.8,4.4-9.8,9.8s4.4,9.8,9.8,9.8s9.8-4.4,9.8-9.8S15.4,0.2,10,0.2z M10,18c-4.4,0-8-3.6-8-8   c0-4.4,3.6-8,8-8s8,3.6,8,8C18,14.4,14.4,18,10,18z"
            ></path>
          </g>
        </svg>
      </a>
      <div class="branding">
        <img :src="logoUrl" class="site_logo">
        <span id="name" class="flc">{{$store.state.siteDetails.site_name}}</span>
      </div>

      <nav class="show-for-medium ">
        <a
          v-if="showMembersBar === false"
          :href="`https://www.${domain}/account/login`"
          class="login"
        >{{$t("loginLinkText")}}</a>
        <a v-else :href="`https://www.${domain}/account`" class="login">{{$t("My Account")}}</a>
      </nav>
      <div class="holder">
        <component v-bind:is="languageDropdown"></component>
      </div>
    </div>
    <div class="bottom_part">
      <div class="row column">
        <h2>{{$t("headerTitle")}}</h2>
      </div>
    </div>
    <div class="quad actions">
      <component name="phone-component" v-bind:is="phoneComponent"></component>

      <div id="membership">
        <p>{{$t("membership")}}</p>
        <a :href="`https://www.${domain}/cancel`">{{$t("cancelTitle")}}</a>
      </div>
    </div>
  </header>
</template>

<script>
import { getComponent, checkUserAuth } from '@/utils/common';

export default {
  name: 'home',
  metaInfo() {
    return {
      titleTemplate: `%s | ${this.$t('headerTitle')}`
    };
  },
  data() {
    return {
      showMembersBar: false
    };
  },
  created() {
    this.checkForMember();
  },
  computed: {
    phoneComponent() {
      return getComponent(this.$store.getters.flowObject, 'phoneModal');
    },

    languageDropdown() {
      return getComponent(this.$store.getters.flowObject, 'languageDropdown');
    },
    logoUrl() {
      return this.$store.state.siteDetails.logo_url;
    },
    domain() {
      return this.$store.state.siteDetails.domain_name;
    }
  },
  methods: {
    hideSuccessMessage() {
      this.$refs.success.classList.add('hiding');
      setTimeout(() => {
        this.$refs.success.classList.add('cleared');
      }, 500);
    },
    menuClick() {
      this.$refs.hamburger.style.display = 'none';
      this.$refs.sideslide.style.display = 'block';
      this.$refs.overlay.style.display = 'block';
      this.$refs.close.style.display = 'inline-block';
      document.querySelector('body').classList.add('stop-scrolling');
    },
    closeClick() {
      this.$refs.hamburger.style.display = 'inline-block';
      this.$refs.sideslide.style.display = 'none';
      this.$refs.overlay.style.display = 'none';
      this.$refs.close.style.display = 'none';
      document.querySelector('body').classList.remove('stop-scrolling');
    },
    checkForMember() {
      if (checkUserAuth()) {
        this.showMembersBar = true;
        return;
      }
      this.showMembersBar = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.cls-1 {
  fill: #fff;
  fill-rule: evenodd;
}
.row {
  max-width: 88.75rem;
  margin-right: auto;
  margin-left: auto;
}
.actions p {
  color: #0a0a0a;
  font-weight: normal;
}
.row.column {
  padding-left: 15px;
  padding-right: 15px;
  h2 {
    color: #0a0a0a;
  }
}
.branding {
  vertical-align: bottom;
  height: 100%;
  display: inline-block;
  span.flc {
    color: #0a0a0a;
  }
}
.site_logo {
  padding: 12.375px 0px 12.375px 0px;
  max-height: 100%;
  width: 40px;
  box-sizing: content-box;
  margin-left: 20px;
  vertical-align: middle;
}
span {
  display: inline-block;
  vertical-align: middle;
  font-size: 25.5px;
}

@media (max-width: 480px) {
  span {
    display: none;
  }
}

@media (max-width: 860px) {
  #membership {
    text-align: center;
  }
}
.overlay {
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  position: fixed;
  top: 0;
  z-index: 2;
  display: none;
}
.top_part {
  background: #fafafa;
  height: 70px;
}
.top_part a {
  text-decoration: none;
}
.top_part .logo {
  display: inline-block;
  height: 70px;
  line-height: 70px;
  padding: 0 20px 0 50px;
  color: #0a0a0a;
  background-repeat: no-repeat;
  background-size: 23%;
  background-position: 12px center;
}
.top_part .langs,
.top_part nav,
.top_part nav a {
  float: right;
}
.top_part nav {
  padding-top: 13px;
  padding-right: 50px;
  height: 70px;
}
.top_part .login {
  background-color: #93cb53;
  color: #fff;
}
.top_part .join_free,
.top_part .langs,
.top_part .login,
.top_part .widget {
  margin: 0 5px;
  color: #fff;
  display: inline-block;
  padding: 12px 34px;
  font-weight: 500;
  font-size: 13px;
  border-radius: 24px;
  -webkit-transition: background-color 0.4s, color 0.4s;
  transition: background-color 0.4s, color 0.4s;
}
.top_part .join_free {
  color: #666;
  background-color: #222;
}
.top_part .langs {
  color: #666;
}
.top_part .join_free:hover,
.top_part .langs:hover,
.top_part .widget:hover {
  background-color: #93cb53;
  color: #fff;
}
.top_part .langs {
  margin-top: 13px;
}
.top_part .widget {
  background-color: #1782df;
}
.top_part .lang_list {
  display: none;
}
.top_part_sm {
  display: none;
}

@media screen and (min-width: 640px) {
  .sideslide {
    display: none;
  }
}

@media screen and (max-width: 639px) {
  .sideslide {
    background-color: #000;
    position: absolute;
    z-index: 2;
    height: 100%;
    top: 70px;
    width: 200px;
    display: none;
  }
  .sideslide a {
    font-size: 14px;
    font-weight: 600;
    text-decoration: none;
    color: #fff;
    padding: 16px 0 16px 20px;
    display: block;
    height: 55px;
    position: relative;
    -webkit-transition: color 0.25s ease;
    -webkit-transition: background-color 0.25s ease;
    transition: background-color 0.25s ease;
  }
  .sideslide a:hover {
    background-color: rgba(255, 255, 255, 0.3);
  }
  .top_part {
    position: relative;
    z-index: 2;
  }
}
@media screen and (max-width: 40.06125em) {
  .show-for-medium {
    display: none !important;
  }
}
@media screen and (max-width: 639px) {
  .logo {
    position: absolute;
    left: 50%;
    margin-left: -105px;
  }
  .close,
  .open {
    display: inline-block;
    width: 70px;
    height: 70px;
    background-color: #93cb53;
    padding: 22px 0 0 22px;
  }
  .close {
    display: none;
  }
}
@media print, screen and (min-width: 40.0625em) {
  .hide-for-medium {
    display: none !important;
  }
}

.holder {
  display: inline-block;
  float: right;
  margin-top: 15px;
}

@media screen and (min-width: 1280px) {
  .quad {
    right: 70px;
  }
}
@media screen and (min-width: 1024px) and (max-width: 1280px) {
  .quad {
    right: 0;
  }
}
.quad div {
  vertical-align: text-top;
  width: 240px;
}
.quad div p {
  font-size: 14px;
  margin: 0 0 4px 0;
}
.quad div span {
  font-size: 10px;
  font-weight: 500;
}
.quad div a {
  font-weight: 500;
  text-decoration: none;
}
.quad div a:hover {
  text-decoration: underline;
}
.quad div:nth-child(1) p:last-child {
  font-weight: 500;
}
.quad div:nth-child(2) a {
  color: #93cb53;
}
.quad div:nth-child(3) a {
  color: #fc3757;
}
@media screen and (min-width: 1024px) {
  .quad {
    position: absolute;
    top: 69px;
    width: 500px;
    height: 107px;
  }
  .quad div {
    height: 100%;
    width: 240px;
    display: inline-block;
  }
  .quad div:nth-child(1) {
    padding: 20px 0 0;
  }
  .quad div:nth-child(2) {
    border-left: 1px solid #e0e0e0;
    padding: 20px 25px 0 25px;
  }
  .quad div:nth-child(3) {
    border-left: 1px solid #e0e0e0;
    padding: 20px 25px 0 25px;
  }
}
@media screen and (max-width: 1023px) and (min-width: 860px) {
  .quad {
    height: 95px;
    border-bottom: 1px solid #e0e0e0;
  }
  .header .actions {
    border: 1px solid #e0e0e0;
    background-color: white;
  }
  .quad div {
    width: 33%;
    height: 100%;
    display: inline-block;
  }
  .quad div:nth-child(1) {
    padding: 20px 20px 0 20px;
  }
  .quad div:nth-child(2) {
    border-left: 1px solid #e0e0e0;
    padding: 20px 20px 0 20px;
  }
  .quad div:nth-child(3) {
    border-left: 1px solid #e0e0e0;
    padding: 20px 20px 0 20px;
  }
}
@media screen and (max-width: 860px) {
  .quad div {
    width: 100%;
    display: inline-block;
    text-align: left;
  }
  .quad div:nth-child(1) {
    border-bottom: 1px solid #e0e0e0;
    padding: 15px 20px 15px 20px;
  }
  .quad div:nth-child(2) {
    border-bottom: 1px solid #e0e0e0;
    padding: 15px 20px 15px 20px;
  }
  .quad div:nth-child(3) {
    border-bottom: 1px solid #e0e0e0;
    padding: 15px 20px 15px 20px;
  }

  .header .actions {
    background-color: white;
  }
}

.bottom_part {
  border-top: 1px solid #e0e0e0;
  background-color: #f2f2f2;
  height: 107px;
}
.bottom_part h2 {
  margin: 0;
  display: inline-block;
  height: 107px;
  line-height: 107px;
}
</style>
